import { render, staticRenderFns } from "./setStartPoint.vue?vue&type=template&id=0a28b26b&scoped=true"
import script from "./setStartPoint.vue?vue&type=script&lang=js"
export * from "./setStartPoint.vue?vue&type=script&lang=js"
import style0 from "./setStartPoint.vue?vue&type=style&index=0&id=0a28b26b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a28b26b",
  null
  
)

export default component.exports